import fetch from '../utils/fetch'

// 獲取模組
export function getTemplate (query) {
  return fetch({
    url: '/espier/upload_template',
    method: 'get',
    params: query
  })
}

// 上傳文件
export function uploadFiles (query) {
  return fetch({
    url: '/espier/upload_file',
    method: 'post',
    params: query
  })
}

// 獲取上傳文件列表
export function getFlieList (query) {
  return fetch({
    url: '/espier/upload_files',
    method: 'get',
    params: query
  })
}

// 處理失敗
export function exportUploadErrorFile (id, query) {
  return fetch({
    url: '/espier/upload_error_file_export/' + id,
    method: 'get',
    params: query
  })
}
